var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "casino-sticky-panel", class: [_vm.activeKey] },
    [
      _c("div", { staticClass: "buttons-container" }, [
        _c("div", {
          staticClass: "close",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _vm._v(" "),
      ["RemoveAllFavorites"].includes(_vm.activeKey)
        ? _c("p", {
            staticClass: "panel-text",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Casino.Tab.Panel.Text." + _vm.activeKey, {
                  count: _vm.itemCount
                })
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeKey === "SortBy"
        ? _c(
            "div",
            _vm._l(_vm.options, function(option) {
              return _c(
                "div",
                { key: option.value, staticClass: "radio-option" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedSortOrder,
                        expression: "selectedSortOrder"
                      }
                    ],
                    attrs: { type: "radio", id: option.id },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.selectedSortOrder, option.value)
                    },
                    on: {
                      change: [
                        function($event) {
                          _vm.selectedSortOrder = option.value
                        },
                        _vm.onRadioChange
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: option.id } }, [
                    _vm._v(_vm._s(option.label))
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeKey === "FilterBy"
        ? _c("div", { staticClass: "filter-section" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t("Casino.Tab.Filter.Title")))]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.$t("Casino.Tab.Filter.Text")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content-wrapper" },
              _vm._l(_vm.filterDropdowns, function(dropdown) {
                return _c(
                  "div",
                  { key: dropdown.id, staticClass: "dropdown" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "dropdown-btn",
                        on: {
                          click: function($event) {
                            return _vm.toggleDropdown(dropdown.id)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.toCapitalCase(dropdown.label)) +
                            "\n          "
                        ),
                        _vm.selectedFilters[dropdown.id] &&
                        _vm.selectedFilters[dropdown.id].length
                          ? _c("span", [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(
                                    _vm.selectedFilters[dropdown.id].length
                                  ) +
                                  ")\n        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "dropdown-arrows" },
                          [
                            _vm.openDropdowns.includes(dropdown.id)
                              ? _c("v-icon", [_vm._v("expand_less")])
                              : _c("v-icon", [_vm._v("expand_more")])
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.openDropdowns.includes(dropdown.id)
                      ? _c(
                          "div",
                          { staticClass: "dropdown-content" },
                          _vm._l(dropdown.options, function(item) {
                            return _c("div", { key: item.id }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedFilters[dropdown.id],
                                    expression: "selectedFilters[dropdown.id]"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: dropdown.id + "-" + item.id
                                },
                                domProps: {
                                  value: item.id,
                                  checked: Array.isArray(
                                    _vm.selectedFilters[dropdown.id]
                                  )
                                    ? _vm._i(
                                        _vm.selectedFilters[dropdown.id],
                                        item.id
                                      ) > -1
                                    : _vm.selectedFilters[dropdown.id]
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a =
                                          _vm.selectedFilters[dropdown.id],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = item.id,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.selectedFilters,
                                              dropdown.id,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.selectedFilters,
                                              dropdown.id,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.selectedFilters,
                                          dropdown.id,
                                          $$c
                                        )
                                      }
                                    },
                                    function($event) {
                                      return _vm.countSelectedFilters()
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: dropdown.id + "-" + item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      ["RemoveAllFavorites", "FilterBy"].includes(_vm.activeKey)
        ? _c(
            "div",
            { staticClass: "casino-tabs-action-buttons" },
            [
              ["FilterBy"].includes(_vm.activeKey)
                ? _c(
                    "v-btn",
                    {
                      staticClass: "button button-close",
                      on: {
                        click: function($event) {
                          return _vm.resetFilters()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("Casino.Tab.Panel.Button.Reset")) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              ["RemoveAllFavorites"].includes(_vm.activeKey)
                ? _c(
                    "v-btn",
                    {
                      staticClass: "button button-close",
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("Casino.Tab.Panel.Button.Close")) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-btn", {
                staticClass: "button button-action",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("Casino.Tab.Panel.Button.Action." + _vm.activeKey, {
                      count:
                        _vm.filteredItems &&
                        _vm.filteredItems.length > 0 &&
                        _vm.filteredItems.length !==
                          _vm.originalPreparedData.length
                          ? "(" + _vm.filteredItems.length + ")"
                          : "" +
                            (_vm.selectedFilterNumberDisplay > 0 ? "(0)" : "")
                    })
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.buttonAction(_vm.activeKey)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75da008d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75da008d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/filterAndSortPanel.vue
// module id = null
// module chunks = 